import axios from "axios";

// ⚠️ CHECK: Ensure this matches your Backend Port (usually 5000 or 8000)
// If your search route is at /api/search, add /api to the end of this URL.
const API_URL =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5172/api";
export const searchProducts = async (query) => {
  try {
    // We use axios directly to avoid the "default().get is not a function" error
    const res = await axios.get(
      `${API_URL}/search?q=${encodeURIComponent(query)}`,
    );
    return res.data;
  } catch (error) {
    console.error("Search request failed:", error);
    return []; // Return empty array so the app doesn't crash
  }
};
